import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const residenceSectionComponent = {
  address: 'residence-section.address',
  amount: 'residence-section.amount',
  duration: 'residence-section.duration',
  editLink: 'residence-section.edit-link',
  h3: 'residence-section.h3',
  residenceType: 'residence-section.residence-type',
  root: 'residence-section.root',
} as const satisfies ComponentLocatorMap;
